<div class="effective-views-card">
  <div class="card-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <mat-icon class="cursor-pointer me-2" (click)="collapsed = !collapsed">
        {{ collapsed ? "chevron_right" : "expand_more" }}
      </mat-icon>
      <strong>Effective Views (Used in Optimization)</strong>
    </div>
    <div class="d-flex align-items-center gap-2">
      <button
        mat-stroked-button
        color="warn"
        class="btn-ghost-outlined"
        (click)="reset.emit()"
        [disabled]="loading || resetLoading"
      >
        @if (resetLoading) {
          <mat-spinner diameter="18" class="d-inline-block me-1"></mat-spinner>
        }
        Reset Views
      </button>
      <button
        mat-flat-button
        color="primary"
        class="rounded-pill"
        (click)="generate.emit()"
        [disabled]="loading || resetLoading"
      >
        @if (loading) {
          <mat-spinner diameter="18" class="d-inline-block me-1"></mat-spinner>
        }
        Generate Payload
      </button>
    </div>
  </div>

  @if (!collapsed) {
    <div class="card-body">
      @if (error) {
        <div class="alert alert-danger mt-2">
          {{ error }}
        </div>
      }
      @if (payload?.length && !error) {
        <table class="table">
          <thead>
            <tr>
              <td>Object</td>
              <td>Source</td>
              <td>Confidence</td>
              <td>Frequency</td>
              <td class="text-end">Effective Value</td>
            </tr>
          </thead>
          <tbody>
            @for (item of payload; track $index) {
              <tr>
                <td>{{ item.resolvedName || item.type }}</td>
                <td class="text-capitalize">{{ item.source_level }}</td>
                <td>
                  @if (item.confidence != null) {
                    {{ item.confidence | confidenceLabel }}
                  }
                </td>
                <td class="text-capitalize">{{ item.frequency }}</td>
                <td class="text-end number-col">
                  {{ item.value | number: "1.0-2" }}%
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (!payload?.length && !error && !loading && !resetEnabled) {
        <p class="text-muted text-center py-3">
          No effective views found. Click "Generate Payload" to merge views from
          all levels.
        </p>
      }
      @if (!payload?.length && !error && !loading && resetEnabled) {
        <p class="text-muted text-center py-3">
          All house views disabled and portfolio views removed. Click "Optimise"
          to run optimization without views.
        </p>
      }
      @if (showOptimize) {
        <div class="text-end mt-3">
          <button
            mat-flat-button
            color="primary"
            class="rounded-pill has-inline-spinner"
            [disabled]="optimizing"
            (click)="optimize.emit()"
          >
            @if (optimizing) {
              <mat-spinner diameter="18"></mat-spinner>
            }
            {{ optimizing ? 'Optimising…' : 'Optimise' }}
          </button>
        </div>
      }
    </div>
  }
</div>
